const errorMessages = {
  hashRequiredValid: 'Hash paramenter is required or must be a valid value'
}

module.exports.errorMessages = errorMessages
